import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppReviewRepository = {
  getById: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/${id}`,
      method: "GET",
    });
  },

  getAllReviews: (page, size, status, searchParams) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/getAppReviews`,
      method: "POST",
      params: {
        page: page,
        size: size,
        status: status,
      },
      data: searchParams,
    });
  },

  getAppReviewsAssignedToCurrentUser: (page, size, status, searchParams) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/getAppReviewsAssignedToCurrentUser`,
      method: "POST",
      params: {
        page: page,
        size: size,
        status: status,
      },
      data: searchParams,
    });
  },

  getAllStatuses: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/statuses`,
      method: "GET",
    });
  },

  assignInstArchiveNumber: (appReviewId, instArchiveNumber) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/assignInstArchiveNumber`,
      method: "PUT",
      params: {
        appReviewId: appReviewId,
        instArchiveNumber: instArchiveNumber,
      },
    });
  },

  handleReviewDecision: (appReviewId, decisionFlag) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/reviewDecision`,
      method: "PUT",
      params: {
        appReviewId: appReviewId,
        decisionFlag: decisionFlag,
      },
    });
  },

  uploadInstitutionDecision: (request) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/uploadInstitutionDecision`,
      method: "POST",
      data: request,
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  generateInstitutionDecision: (appReviewId, parameters, approved) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/generateInstitutionDecision`,
      method: "POST",
      data: {
        appReviewId: appReviewId,
        approved: approved,
        parameters: parameters,
      },
      responseType: "blob",
    });
  },

  getInstitutionDecisionTemplate: (appReviewId, approved) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecisionTemplate/${appReviewId}`,
      method: "GET",
      params: {
        approved: approved,
      },
    });
  },

  signAndUploadInstitutionDecision: (formData) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecision/signAndUpload`,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  uploadSignedInstitutionDecision: (formData) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecision/uploadSignedDocument`,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  submitForSignature: (formData) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecision/submitForSignature`,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getDecisionsForSigning: ({ page, size }) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/decisionsForSigning?page=${page}&size=${size}`,
      method: "GET",
    });
  },

  getDecisionDocumentForSigning: (appReviewId) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecision/getDecisionForSigning/${appReviewId}`,
      method: "GET",
      responseType: "blob",
    });
  },

  returnForCorrection: (appReviewId, comment) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/institutionDecision/returnForCorrection`,
      method: "POST",
      data: {
        appReviewId: appReviewId,
        comment: comment,
      },
    });
  },

  markOutputDocumentAsArchived: (appReviewId, checked) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appReviews/archiveOutputDoc/${appReviewId}/${checked ? "true" : "false"}`,
      method: "PUT",
    });
  },
};
